import React from "react";
import css from "./styles.scss";
import { Div } from "components/Base";

function getRecordLocation({ pageSize, page, total }) {
  const firstRecord = pageSize * page + 1;
  const finalRecord = firstRecord + Math.min(total - firstRecord, pageSize - 1);
  return [firstRecord, finalRecord];
}

const PageLocation = ({ pageSize, page, rowsText, total }) => {
  if (total > pageSize) {
    return (
      <Div display="row.flex-start.center" style={{ gap: "5px" }}>
        {`${getRecordLocation({ pageSize, page, total }).join(" — ")} of `}
        <span className={css.bold}>{`${total} ${rowsText}`}</span>
      </Div>
    );
  }
  return (
    <Div display="row.flex-start.center">
      <span className={css.bold}>{`${total} ${rowsText}`}</span>
    </Div>
  );
};

export default PageLocation;
